import { jsx as _jsx } from "react/jsx-runtime";
/* Button — three variants matching DESIGN-SYSTEM.md §5 buttons.
 *
 * Heights: 32 / 36 / 40 / 48 px (sm/md/lg/xl).
 * Padding-x: 12 / 16 / 20 / 24.
 * Border-radius: 6px (--radius-sm).
 *
 * Stay token-parity with packages/design-system-svelte/Button.svelte. */
import { forwardRef } from 'react';
const sizeStyles = {
    sm: { height: '32px', paddingX: '12px', fontSize: '13px' },
    md: { height: '36px', paddingX: '16px', fontSize: '14px' },
    lg: { height: '40px', paddingX: '20px', fontSize: '14px' },
    xl: { height: '48px', paddingX: '24px', fontSize: '15px' },
};
function variantStyles(variant) {
    switch (variant) {
        case 'primary':
            return {
                background: 'var(--ink-primary)',
                color: 'var(--bg-base)',
                border: '1px solid transparent',
            };
        case 'secondary':
            return {
                background: 'var(--bg-surface)',
                color: 'var(--ink-primary)',
                border: '1px solid var(--border-hairline)',
            };
        case 'ghost':
            return {
                background: 'transparent',
                color: 'var(--ink-secondary)',
                border: '1px solid transparent',
            };
        case 'destructive':
            return {
                background: 'transparent',
                color: 'var(--signal-alarm)',
                border: '1px solid var(--signal-alarm)',
            };
    }
}
export const Button = forwardRef(function Button({ variant = 'secondary', size = 'md', style, disabled, children, ...rest }, ref) {
    const dim = sizeStyles[size];
    const vstyles = variantStyles(variant);
    const merged = {
        height: dim.height,
        paddingLeft: dim.paddingX,
        paddingRight: dim.paddingX,
        fontSize: dim.fontSize,
        fontWeight: 500,
        fontFamily: "'Geist', 'Inter Tight', -apple-system, BlinkMacSystemFont, sans-serif",
        borderRadius: 'var(--radius-sm)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        transition: 'background var(--duration-fast) var(--easing-standard)',
        outline: 'none',
        whiteSpace: 'nowrap',
        ...vstyles,
        ...style,
    };
    return (_jsx("button", { ref: ref, disabled: disabled, style: merged, ...rest, children: children }));
});
//# sourceMappingURL=Button.js.map